import { useApp } from '../store';

/*
 * THE STAGES THIS PROJECT RUNS IN — now managed on the Plan, not here. #377 /
 * projectization, decision D4.
 *
 * Phases used to be created, dated, reordered and given a status in this Settings
 * panel, while the work inside them was done on the Plan — so standing a project
 * up meant bouncing between the two screens. That seam is closed: the whole plan
 * lives on the Plan screen now, where a phase is a row over its board cards. This
 * panel is kept as the signpost, so anyone who comes to Settings looking for the
 * phases is sent one click to where they are.
 */
export default function PhaseSettings() {
  const setView = useApp((s) => s.setView);

  return (
    <section className="panel">
      <h2>The stages this project runs in</h2>
      <p className="hint">
        Phases live on the <strong>Plan</strong> now — one surface, where a phase is the board cards
        that run in it. Create, rename, re-date, reorder and remove them there, and each phase&rsquo;s
        status follows its cards. Nothing about the plan is set here any more, so the two screens can
        never disagree.
      </p>
      <button className="btn btn-primary" onClick={() => setView('plan')}>
        Open the Plan
      </button>
    </section>
  );
}
